/* global Instafeed loadEventSliders */
const feed = {

	el: {
		container: document.getElementById('instafeed')
	},

	events() {
		const feed = new Instafeed({
			accessToken: this.el.container.dataset.token,
			template: `
				<div class="swiper-slide">
					<a href="{{link}}" target="_blank">
						<div class="social-gallery__slider-item">
							<figure class="social-gallery__slider-figure">
								<img class="social-gallery__slider-img img-full" src="{{image}}" alt="{{caption}}" title="{{caption}}">
							</figure>
						</div>
					</a>
				</div>
			`,
			after: () => loadEventSliders.init()
		})
		feed.run()
	},

	init() {
		this.el.container && this.events()
	}
}

feed.init()